import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import ProductCreate from "pages/products/ProductCreate";
import React from "react";

const ProductEditDialog = ({ open, handleClose, product }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Update product"
    >
      <Box sx={{ overflow: "hidden", padding: 2 }}>
        <ProductCreate fullGrid={true} product={product} />
      </Box>
    </CustomDialog>
  );
};

export default ProductEditDialog;
